module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderDetail"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('orderDetail_title'),
      "url": "/orderList"
    }
  }), _vm._v(" "), (_vm.orderInfo.masterBase) ? _c('div', {
    staticClass: "warp"
  }, [_c('div', {
    staticClass: "orderSta clearfix"
  }, [_c('div', {
    staticClass: "Num"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail_crsNo')) + ":\n          "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.masterBase.crsNo == '' ? _vm.orderInfo.masterBase.rsvNo : _vm.orderInfo.masterBase.crsNo))])]), _vm._v(" "), _c('div', {
    staticClass: "sta"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail_sta')) + ":\n          "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.masterBase.sta))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v("\n            " + _vm._s(_vm.$t('orderDetail_checkIn_info')) + "\n          ")]), _vm._v(" "), _vm._l((_vm.noPain), function(item) {
    return _c('ul', {
      key: item.id,
      staticClass: "infoContent"
    }, [_c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_rsvArrDate')) + ":\n              "), _vm._v(" "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(item.rsvArrDate))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_rsvDepDate')) + ":\n              "), _vm._v(" "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(item.rsvDepDate))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_rmtypes')) + ":\n              "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(_vm.getRmType(item.rmtype)) + "*" + _vm._s(item.rmnum) + _vm._s(_vm.$t('orderDetail_rmtypes_unit')))])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [(!item.rmno && (_vm.$hasPermission('mh!resrv!assign', _vm.rights.indexOf('resrv!assignroom') >= 0))) ? _c('div', {
      staticClass: "paiF",
      on: {
        "click": function($event) {
          return _vm.gearRoom(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('orderDetail_paiF')) + "\n              ")]) : _vm._e()])])
  }), _vm._v(" "), _vm._l((_vm.orderInfo.masterLinkList), function(item) {
    return _c('ul', {
      key: item.id,
      staticClass: "infoContent twocol "
    }, [_c('li', {
      staticClass: "p100",
      attrs: {
        "id": 'r' + item.masterBase.rmno
      }
    }, [_vm._v(_vm._s(_vm.$t('orderDetail_arr')) + ":\n              "), _vm._v(" "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(item.masterBase.arr) + " ")]), _vm._v(" "), ((item.masterBase.sta == 'R' || item.masterBase.sta == 'I') && _vm.$hasPermission('mh!recpt!edit', _vm.rights.indexOf('recept!fit!ci') >= 0)) ? _c('div', {
      staticClass: "addGuest",
      on: {
        "click": function($event) {
          return _vm.addGuest(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-jia"
    })]) : _vm._e()]), _vm._v(" "), _c('li', {
      staticClass: "p100"
    }, [_vm._v(_vm._s(_vm.$t('orderDetail_dep')) + ":\n              "), _vm._v(" "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(item.masterBase.dep))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_rmtypes')) + ":\n              "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(_vm.getRmType(item.masterBase.rmtype)))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_realRate')) + ":\n              "), _c('span', {
      staticClass: "infoVal"
    }, [_c('small', [_vm._v("￥")]), _vm._v(_vm._s(item.masterBase.realRate) + "\n                "), _c('i', {
      staticClass: "mintui mintui-more",
      on: {
        "click": function($event) {
          return _vm.getEveryDateRate(item.masterBase)
        }
      }
    })])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_name')) + ":\n              "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(item.masterGuest.name))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_sex')) + ":\n              "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(item.masterGuest.sex == 1 ? _vm.$t('orderDetail_sex1') : (item.masterGuest.sex == 2 ? _vm.$t('orderDetail_sex2') : '')))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_mobile')) + ":\n              "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(item.masterGuest.mobile))])]), _vm._v(" "), _c('li', {
      staticClass: "p100"
    }, [_vm._v(_vm._s(_vm.$t('orderDetail_idNo')) + ":\n              "), _c('span', {
      staticClass: "infoVal"
    }, [_vm._v(_vm._s(item.masterGuest.idNo) + "\n                "), (_vm.isJingJiang && _vm.$hasPermission('mh!recpt!edit', true)) ? _c('i', {
      staticClass: "iconfont icon-credentials_icon",
      staticStyle: {
        "margin-left": "0.5rem",
        "color": "#999",
        "margin-top": "0.1rem"
      },
      on: {
        "click": function($event) {
          return _vm.getFirstToken(item)
        }
      }
    }) : [(_vm.sfzR && _vm.$hasPermission('mh!recpt!edit', _vm.rights.indexOf('recept!fit!ci') >= 0)) ? _c('i', {
      staticClass: "iconfont icon-saoma",
      staticStyle: {
        "margin-left": "0.5rem",
        "color": "#999"
      },
      on: {
        "click": function($event) {
          return _vm.sfzRe(item)
        }
      }
    }) : _vm._e()]], 2)]), _vm._v(" "), _c('li', {
      staticClass: "p100"
    }, [_vm._v(_vm._s(_vm.$t('orderDetail_rsvNo')) + ":"), _c('span', [_c('router-link', {
      attrs: {
        "tag": "span",
        "to": '/fangTXQ?id=' + item.masterBase.id + '&redirect=/orderDetail%3frsvNo%3d' + _vm.orderInfo.masterBase.rsvNo
      }
    }, [_vm._v(" " + _vm._s(item.masterBase.rmno) + " "), _c('i', {
      staticClass: "mintui mintui-more"
    })])], 1), _vm._v(" "), (_vm.isJingJiang) ? _c('div', {
      staticClass: "menka",
      on: {
        "click": function($event) {
          return _vm.openJingJiangModal(item.masterBase)
        }
      }
    }, [_vm._v("门卡\n              ")]) : _vm._e(), _vm._v(" "), (item.masterBase.sta == 'R' && _vm.$hasPermission('mh!resrv!checkin', _vm.rights.indexOf('recept!fit!ci') >= 0)) ? _c('div', {
      staticClass: "ruZ",
      on: {
        "click": function($event) {
          return _vm.checkIn(item.masterBase.id)
        }
      }
    }, [_vm._v("入住\n              ")]) : (item.masterBase.sta == 'I') ? _c('div', {
      staticClass: "paiF"
    }, [_vm._v(_vm._s(_vm.$t('orderDetail_staI')) + "\n              ")]) : (item.masterBase.sta == 'O') ? _c('div', {
      staticClass: "paiF"
    }, [_vm._v(_vm._s(_vm.$t('orderDetail_staO')) + "\n              ")]) : (item.masterBase.sta == 'S') ? _c('div', {
      staticClass: "paiF"
    }, [_vm._v(_vm._s(_vm.$t('orderDetail_staS')) + "\n              ")]) : (item.masterBase.sta == 'X') ? _c('div', {
      staticClass: "paiF"
    }, [_vm._v(_vm._s(_vm.$t('orderDetail_staX')) + "\n              ")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.orderInfo.masterBase.realRate > 0) ? _c('div', {
    staticClass: "totalmoney",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('orderDetail_realRate')) + ":\n            "), _c('span', [_c('small', [_vm._v("￥")]), _vm._v(_vm._s(_vm.orderInfo.masterBase.realRate) + " "), (_vm.orderInfo.masterBase.isSecretRate == 'T') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.$t('orderDetail_isSecretRate')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "totalmoney"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('orderDetail_totalmoney')) + ":\n            "), _c('span', [_c('small', [_vm._v("￥")]), _vm._v(_vm._s(_vm.orderInfo.feeTotal) + " "), (_vm.orderInfo.masterBase.isSecretRate == 'T') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.$t('orderDetail_isSecretRate')))]) : _vm._e()])])], 2), _vm._v(" "), _c('div', {
    staticClass: "info "
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v(" "), _vm._v("\n\n            " + _vm._s(_vm.$t('orderDetail_bookInfo')) + "\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent twocol"
  }, [_c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail_bookName')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterGuest.name) + "\n                "), (_vm.orderInfo.masterBase.sta == 'R') ? _c('i', {
    staticClass: "iconfont icon-xiugai",
    on: {
      "click": _vm.updatePersonInfo
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail_mobile')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_c('a', {
    attrs: {
      "href": "tel:" + _vm.orderInfo.masterGuest.mobile
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.masterGuest.mobile))])])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('orderDetail_memberNo')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.memberNo))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_arr')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.arr))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_dep')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.dep))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_companyName')) + " :"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.companyName))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_agentName')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.agentName))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_sourceName')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.sourceName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v(" "), _vm._v("\n            " + _vm._s(_vm.$t('fangTXQ_market_sales')) + "\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent twocol"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_salesman')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.salesman))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_rsvTypeName')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.rsvTypeName))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(" " + _vm._s(_vm.$t('book_market')) + ":\n\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.market))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('book_src')) + " :\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.src))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_market')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.ratecode))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_channel')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.channel))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_cmscode')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.cmscode))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_payCode')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.payCode))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_crsNo')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.crsNo))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_packagesDis')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.packagesDis))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_creditMan')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.creditMan))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_otaRsvNo')) + ":\n              "), _c('span', {
    staticClass: "infoVal",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.otaRsvNo))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v(" "), _vm._v("\n\n            " + _vm._s(_vm.$t('orderDetail_payment_info')) + "\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_pay')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v("￥" + _vm._s(_vm.orderInfo.masterBase.pay.toFixed(2)))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_credit')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v("￥" + _vm._s(_vm.orderInfo.masterBase.credit.toFixed(2)))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_charge')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v("￥" + _vm._s((_vm.orderInfo.masterBase.charge - _vm.orderInfo.masterBase.pay).toFixed(2)))])]), _vm._v(" "), (_vm.orderInfo.masterBase.coMsg) ? _c('li', {
    staticClass: "ha"
  }, [_vm._v(" " + _vm._s(_vm.$t('fangTXQ_coMsg')) + "："), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.coMsg))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "info",
    staticStyle: {
      "padding-top": "2000"
    },
    attrs: {
      "id": "sss"
    }
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v(" "), _vm._v("\n\n            " + _vm._s(_vm.$t('other')) + "\n\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent",
    staticStyle: {
      "border-bottom": "0"
    }
  }, [_c('li', {
    staticClass: "ha"
  }, [_vm._v(" " + _vm._s(_vm.$t('fangTXQ_amenities')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.amenities))])]), _vm._v(" "), _c('li', {
    staticClass: "ha"
  }, [_vm._v(" " + _vm._s(_vm.$t('fangTXQ_specials')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.specials))])]), _vm._v(" "), _c('li', {
    staticClass: "ha"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_remark')) + " :\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.remark) + "\n                "), (_vm.$hasPermission('mh!resrv!cmme!up', _vm.rights.indexOf('resrv!fit!edit') >= 0)) ? _c('i', {
    staticClass: "iconfont icon-xiugai",
    on: {
      "click": _vm.updateRemark
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li', [_vm._v(" " + _vm._s(_vm.$t('fangTXQ_createUser')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.createUser))])]), _vm._v(" "), _c('li', [_vm._v(" " + _vm._s(_vm.$t('fangTXQ_createDatetime')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.createDatetime))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_modifyUser')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.modifyUser))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_modifyDatetime')) + ":\n              "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.masterBase.modifyDatetime))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dx"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('loading_end_message')) + " ")])]), _vm._v(" "), _c('mt-palette-button', {
    ref: "target_1",
    staticClass: "pb",
    staticStyle: {
      "right": "30px"
    },
    attrs: {
      "content": "+",
      "direction": "lt",
      "radius": 80,
      "mainButtonStyle": "color:#fff;background-color:#f6a624;"
    }
  }, [(_vm.useQrcodePay) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": _vm.showQrcodeModal
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": function($event) {
        _vm.sub_log();
        _vm.searchRoomVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo"
  })]), _vm._v(" "), (_vm.$hasPermission('mh!resrv!pay', _vm.rights.indexOf('act!posting') >= 0)) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": function($event) {
        return _vm.doCheckShift('goIncomeAccount')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-JZQK"
  })]) : _vm._e(), _vm._v(" "), (_vm.isJingJiang) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": _vm.openPrintSelectModal
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dayin"
  })]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.masterBase.sta == 'R' && (_vm.$hasPermission('mh!resrv!cancel', _vm.rights.indexOf('resrv!fit!cxl') >= 0))) ? _c('div', {
    staticClass: "my-icon-button indexicon icon-popup",
    on: {
      "click": function($event) {
        _vm.sub_log();
        _vm.cancelOrder()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-cuowu"
  })]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('selectShift', {
    ref: "selectShiftRef",
    on: {
      "success": _vm.setShift
    }
  }), _vm._v(" "), _c('mt-popup', {
    staticClass: "setroom",
    attrs: {
      "position": "right",
      "modal": false
    },
    model: {
      value: (_vm.popupVisible),
      callback: function($$v) {
        _vm.popupVisible = $$v
      },
      expression: "popupVisible"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('i', {
    staticClass: "iconfont icon-zuo",
    on: {
      "click": _vm.canclePop
    }
  }), _vm._v(" "), _vm._v("\n\n        " + _vm._s(_vm.$t('orderDetail_checkin')) + "\n\n        "), _vm._v(" "), _c('div', {
    staticClass: "sureGear",
    on: {
      "click": _vm.submitGear
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "infoTitle"
  }, [_vm._v("\n        " + _vm._s(_vm.gearRoomInfo.rmtype) + " " + _vm._s(_vm.gearRoomInfo.rmnum) + " " + _vm._s(_vm.$t('index_homeData_analy_unit')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "optional selected clearfix"
  }, _vm._l((_vm.gearRoomInfo.rmnum), function(n) {
    return _c('div', {
      key: n,
      staticClass: "option",
      class: {
        rowDatas: !!_vm.confineRoom[n] && _vm.confineRoom[n].type == 'rowDatas', InDatas: !!_vm.confineRoom[n] && _vm.confineRoom[n].type == 'InDatas'
      }
    }, [_vm._v("\n          " + _vm._s(_vm._f("showConfine")(_vm.confineRoom[n])) + "\n          "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.confineRoom[n]),
        expression: "confineRoom[n]"
      }],
      staticClass: "cleartext",
      on: {
        "click": function($event) {
          return _vm.vShowDelete(n)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-cuowu"
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "room-status-select"
  }, [_c('div', {
    staticClass: "status-select-title"
  }, [_vm._v(_vm._s(_vm.$t('fangT_title')))]), _vm._v(" "), _c('div', _vm._l((_vm.roomStatusArr), function(item, index) {
    return _c('span', {
      key: 'roomStatusArr' + index,
      staticClass: "status-item",
      class: {
        active: item.isActive
      },
      on: {
        "click": function($event) {
          return _vm.chooseRoomStatus(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "optional",
    staticStyle: {
      "height": "65%",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.gearRoomInfo.roomStatus), function(item) {
    return _c('div', {
      key: item,
      staticClass: "option",
      class: {
        choose: _vm.selectedroom.indexOf(item) != -1
      },
      on: {
        "click": function($event) {
          return _vm.selectRoom(item)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "plan",
    on: {
      "click": function($event) {
        return _vm.pushSelected(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('orderDetail_paiF')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "checkIn",
    on: {
      "click": function($event) {
        return _vm.pushSelected(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('fangT_walkBook')) + "\n        ")])])]), _vm._v(" "), (_vm.updateGuest) ? _c('mt-popup', {
    staticClass: "guestInfo",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.guestPopVisible),
      callback: function($$v) {
        _vm.guestPopVisible = $$v
      },
      expression: "guestPopVisible"
    }
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.$t('orderDetail_guest_info')))]), _vm._v(" "), _c('div', {
    staticClass: "guestSwiper"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('fangTXQ_rmno')) + "：\n          "), _c('span', {
    staticClass: "formRoomNum"
  }, [_vm._v(" " + _vm._s(_vm.updateGuest.masterBase.rmno))])]), _vm._v(" "), _c('div', {
    staticClass: "infoToWrite"
  }, [_c('mt-field', {
    attrs: {
      "label": _vm.$t('fangTXQ_name'),
      "placeholder": _vm.$t('orderDetail_guest_name_placeholder')
    },
    model: {
      value: (_vm.updateGuest.masterGuest.name),
      callback: function($$v) {
        _vm.$set(_vm.updateGuest.masterGuest, "name", $$v)
      },
      expression: "updateGuest.masterGuest.name"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": _vm.$t('fangTXQ_idNo'),
      "placeholder": _vm.$t('fangTXQ_idNo_placeholder')
    },
    model: {
      value: (_vm.updateGuest.masterGuest.idNo),
      callback: function($$v) {
        _vm.$set(_vm.updateGuest.masterGuest, "idNo", $$v)
      },
      expression: "updateGuest.masterGuest.idNo"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": _vm.$t('orderDetail_mobile'),
      "placeholder": _vm.$t('orderDetail_mobile_placeholder')
    },
    model: {
      value: (_vm.updateGuest.masterGuest.mobile),
      callback: function($$v) {
        _vm.$set(_vm.updateGuest.masterGuest, "mobile", $$v)
      },
      expression: "updateGuest.masterGuest.mobile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": _vm.cancleGuestPop
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.changGuest
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n        ")])])]) : _vm._e(), _vm._v(" "), _c('updateRemark', {
    ref: "upRemark",
    on: {
      "success": _vm.getOrderDetail
    }
  }), _vm._v(" "), _c('mt-popup', {
    staticClass: "guestInfo",
    staticStyle: {
      "width": "80%",
      "height": "250px"
    },
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.searchRoomVisible),
      callback: function($$v) {
        _vm.searchRoomVisible = $$v
      },
      expression: "searchRoomVisible"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('orderDetail_search_room')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "guestSwiper",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "infoToWrite"
  }, [_c('mt-field', {
    attrs: {
      "label": _vm.$t('fangT_rmno'),
      "placeholder": _vm.$t('fangT_rmno_placeholder')
    },
    model: {
      value: (_vm.searchRmno),
      callback: function($$v) {
        _vm.searchRmno = $$v
      },
      expression: "searchRmno"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": _vm.$t('orderDetail_guest_name'),
      "placeholder": _vm.$t('orderDetail_guest_name_placeholder')
    },
    model: {
      value: (_vm.searchName),
      callback: function($$v) {
        _vm.searchName = $$v
      },
      expression: "searchName"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": function($event) {
        _vm.searchRoomVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.searchRoom
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n        ")])])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "everyDatePop",
    attrs: {
      "position": "bottom",
      "modal": true
    },
    model: {
      value: (_vm.popupEvalDay),
      callback: function($$v) {
        _vm.popupEvalDay = $$v
      },
      expression: "popupEvalDay"
    }
  }, [_c('table', {
    staticClass: "checkList",
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangQ_date')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('book_reason')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_realRate')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_rmnum')))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('fangTXQ_total')))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sumRate(_vm.dateRate)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((_vm.dateRate), function(item) {
    return _c('tr', {
      key: item.rsv_date
    }, [_c('td', [_vm._v(_vm._s(_vm._f("dateF")(item.rsv_date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.reasonObj[item.dscResaon] || ''))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("￥")]), _vm._v("\n            " + _vm._s(item.realShareRate) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rmnum))])])
  })], 2)]), _vm._v(" "), _c('jingJiangModal', {
    ref: "jingJiang",
    on: {
      "success": _vm.closeJingJiangModal
    }
  }), _vm._v(" "), (_vm.doorCardModalShow) ? _c('div', {
    staticClass: "door-card-modal"
  }, [_c('div', {
    staticClass: "door-card-container"
  }, [_c('div', {
    staticClass: "door-card-title"
  }, [_vm._v(_vm._s(_vm.$t('jj_door_card_info')))]), _vm._v(" "), _c('div', {
    staticClass: "door-card-info"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('jj_room_no')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "info-item-content"
  }, [_vm._v(_vm._s(_vm.ResponseParameters.roomNo))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('jj_beginTime')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "info-item-content"
  }, [_vm._v(_vm._s(_vm.ResponseParameters.beginTime))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('jj_endTime')) + "：")]), _vm._v(" "), _c('div', {
    staticClass: "info-item-content"
  }, [_vm._v(_vm._s(_vm.ResponseParameters.endTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "door-card-bottom"
  }, [_c('div', {
    staticClass: "door-btns",
    on: {
      "click": _vm.closeDoorCardModal
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.printSelectModalShow) ? _c('div', {
    staticClass: "print-select-modal"
  }, [_c('div', {
    staticClass: "door-card-container"
  }, [_c('div', {
    staticClass: "door-card-title"
  }, [_vm._v("打印")]), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "spe-row"
  }, [_c('div', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.getListBillSceneLink("RECEPT")
      }
    }
  }, [_vm._v("打印登记单\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-default",
    on: {
      "click": _vm.getListDeposit
    }
  }, [_vm._v("打印定金单\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "spe-row"
  }, [_c('div', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.getListBillSceneLink("FO_BILL")
      }
    }
  }, [_vm._v("打印账单\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "door-card-bottom"
  }, [_c('div', {
    staticClass: "door-btns",
    on: {
      "click": _vm.closePrintSelectModal
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('mt-popup', {
    staticClass: "selectShift select-wrap",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('h2', [_vm._v("押金记录")]), _vm._v(" "), _c('div', {
    staticClass: "select-list-wrap"
  }, [_c('mt-radio', {
    attrs: {
      "options": _vm.listDeposit
    },
    model: {
      value: (_vm.currentCode),
      callback: function($$v) {
        _vm.currentCode = $$v
      },
      expression: "currentCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": function($event) {
        _vm.showPop = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n        ")])])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "selectShift select-wrap",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.showPop2),
      callback: function($$v) {
        _vm.showPop2 = $$v
      },
      expression: "showPop2"
    }
  }, [_c('h2', [_vm._v("选择场景")]), _vm._v(" "), _c('div', {
    staticClass: "select-list-wrap"
  }, [_c('mt-radio', {
    attrs: {
      "options": _vm.listBillSceneLink
    },
    model: {
      value: (_vm.currentCode2),
      callback: function($$v) {
        _vm.currentCode2 = $$v
      },
      expression: "currentCode2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": function($event) {
        _vm.showPop2 = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.save2
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n        ")])])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "guestInfo base-spe",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.changeBaseInfoModal),
      callback: function($$v) {
        _vm.changeBaseInfoModal = $$v
      },
      expression: "changeBaseInfoModal"
    }
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.$t('orderDetail_bookName')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "guestSwiper"
  }, [_c('div', {
    staticClass: "infoToWrite"
  }, [_c('mt-field', {
    attrs: {
      "label": _vm.$t('fangTXQ_name'),
      "placeholder": _vm.$t('orderDetail_guest_name_placeholder')
    },
    model: {
      value: (_vm.tempObj.userName),
      callback: function($$v) {
        _vm.$set(_vm.tempObj, "userName", $$v)
      },
      expression: "tempObj.userName"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": _vm.$t('orderDetail_mobile'),
      "placeholder": _vm.$t('orderDetail_mobile_placeholder'),
      "type": "number"
    },
    model: {
      value: (_vm.tempObj.mobile),
      callback: function($$v) {
        _vm.$set(_vm.tempObj, "mobile", $$v)
      },
      expression: "tempObj.mobile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": _vm.cancleBasePop
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.changeBaseInfo
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n        ")])])]), _vm._v(" "), _c('form-qr-code-modal', {
    ref: "formQrCodeModal",
    on: {
      "emitFormQrCode": _vm.emitFormQrCode
    }
  }), _vm._v(" "), _c('qrcode-modal', {
    ref: "qrCodeModal"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1b9c11f4","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/orderDetail.vue
// module id = 1743
// module chunks = 107